import { createSlice } from '@reduxjs/toolkit'
import validator from 'react-validation';

const userSlice = createSlice({
    name: "user",
    initialState: {
        uid:Math.random().toString(8).slice(-6),
        name:"",
        room:"",
        isAgree:false,
        isVerify:false,
    },
    reducers: {
        setUserProfile(state, action) {
            const { name, room, isAgree, isVerify } = action.payload
            state.name = name
            state.room = room
            state.isAgree = isAgree
            state.isVerify= isVerify
            if(isVerify == null || isVerify == undefined) {
                state.isVerify= false
            }

            if(state.isAgree && state.isVerify) {

            }
        }
    }
})

export const { setUserProfile } = userSlice.actions

export default userSlice.reducer
